import { useQuery } from '@tanstack/react-query';

import {
  type RuleRecommendationDetails,
  type RuleRecommendationsListParams,
  type RuleRecommendationsListResponse,
  RuleRecommendationsService,
} from '../services';

/**
 * Hook to fetch paginated list of rule recommendations
 * @param params - Query parameters for filtering and pagination
 * @returns React Query result with rule recommendations data
 */
export const useRuleRecommendations = (
  params: RuleRecommendationsListParams = {}
) =>
  useQuery<RuleRecommendationsListResponse>({
    queryKey: ['ruleRecommendations', params],
    queryFn: () => RuleRecommendationsService.getRuleRecommendations(params),
  });

/**
 * Hook to fetch detailed information for a specific rule recommendation
 * @param recommendedObjectKey - Unique identifier for the rule recommendation
 * @returns React Query result with rule recommendation details
 */
export const useRuleRecommendationDetails = (recommendedObjectKey: number) =>
  useQuery<RuleRecommendationDetails>({
    queryKey: ['ruleRecommendationDetails', recommendedObjectKey],
    queryFn: () =>
      RuleRecommendationsService.getRuleRecommendationDetails(
        recommendedObjectKey
      ),
    enabled: !!recommendedObjectKey,
  });
